import { inject, Injectable } from '@angular/core';
import { map, Observable, shareReplay } from 'rxjs';
import { ProjectInfoDataSource } from './project-info.datasource';
import { ProjectInfoMapper } from './project-info.mapper';
import { ProjectInfo } from '../models/project-info.types';

@Injectable({ providedIn: 'root' })
export class ProjectInfoService {
  private dataSource = inject(ProjectInfoDataSource);
  private mapper = inject(ProjectInfoMapper);

  private cache = new Map<string, Observable<ProjectInfo>>();

  getProjectInfo(projectId: string): Observable<ProjectInfo> {
    const cached = this.cache.get(projectId);
    if (cached) {
      return cached;
    }

    const info$ = this.dataSource.getProjectInfo(projectId).pipe(
      map(response => this.mapper.mapToProjectInfo(response)),
      shareReplay(1),
    );

    this.cache.set(projectId, info$);
    return info$;
  }

  invalidate(projectId: string): void {
    this.cache.delete(projectId);
  }
}
